export default __webpack_public_path__ + "static/shape_round_male-e3d4668c5de958e619f900edacadcb3d.png";